export const SET_USER_LOGADO = "SET_USER_LOGADO"
export const SET_ADRESS_USER = "SET_ADRESS_USER"
export const SET_DATA_END_ORDER = "SET_DATA_END_ORDER"
export const SET_ADRESS_TO_DELIVERY = "SET_ADRESS_TO_DELIVERY"
export const SET_ITENS = "SET_ITENS"
export const SET_STORES = "SET_STORES"